// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".spectrum-table-array-control div[role='rowheader'] > span,\n.spectrum-table-array-control div[role='gridcell'] > span {\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
